

document.addEventListener('DOMContentLoaded', function() {

     // Función para capitalizar los textos de .grid-product__title
     function capitalizeGridProductTitles() {
        const titles = document.querySelectorAll('.grid-product__title');
        
        if (titles.length > 0) {
            titles.forEach(function(title) {
            //    title.textContent = title.textContent.toUpperCase();
                title.textContent = title.textContent
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

               // console.log('title' + title.textContent)
            });
        }
    }

   

    const elemList = document.getElementById('list-view');
    const elemGrid = document.getElementById('grid-view');
    let container = document.getElementById('Huratips-Loop');

    if (elemList != null){
        // your code here.
    elemList.addEventListener('click', function handleClick() {
        container.classList.add('list-view'); 
        elemList.classList.add('disabled');  
        elemGrid.classList.remove('disabled');    
    });
    }



    if (elemList != null){
        elemGrid.addEventListener('click', function handleClick() {
            container.classList.remove('list-view'); 
            elemList.classList.remove('disabled');
            elemGrid.classList.add('disabled');    
        });
}

    // Ejecuta la capitalización al cargar la página
    capitalizeGridProductTitles();
    
    // Aquí puedes agregar más código JavaScript que necesites ejecutar al cargar la página
    
});
